import ProjectDetails from "../../components/user/projects-details/ProjectDetails";
import UserTemplate from "../../views/UserTemplate";

const ProjectDetailPage = () => {
  return (
    <UserTemplate>
      <ProjectDetails />
    </UserTemplate>
  );
};

export default ProjectDetailPage;
